import React from 'react';
import { X } from 'lucide-react';

const PhotoZoomModal = ({ isOpen, onClose, photo, name }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
      >
        <X className="h-6 w-6 text-white" />
      </button>
      <div className="text-center" onClick={(e) => e.stopPropagation()}>
        {photo ? (
          <img 
            src={photo} 
            alt={name}
            className="max-w-full max-h-[80vh] rounded-lg shadow-2xl"
          />
        ) : (
          <div className="w-64 h-64 rounded-lg bg-gradient-to-br from-[#D87A4E] to-[#c26a42] flex items-center justify-center">
            <span className="text-6xl font-bold text-white">
              {name?.charAt(0)?.toUpperCase()}
            </span>
          </div>
        )}
        <p className="text-white text-lg mt-4 font-medium">{name}</p>
      </div>
    </div>
  );
};

export default PhotoZoomModal;
